<template>
  <div class="body-max-width center">
    <Header back="/home" :title="$t('healthPackage')"></Header>
    <div class="searching-package mt-40" id="searchField">
      <div class="search-icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 9.84871 15.3729 11.551 14.3199 12.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L12.9056 14.3199C11.551 15.3729 9.84871 16 8 16C3.58172 16 0 12.4183 0 8Z"
            fill="#3F3F3F"
          />
        </svg>
      </div>
      <input
        :placeholder="$t('search')"
        v-model="searchPagkage"
        class="input-style"
        type="text"
      />

      <!-- <div class="mic-icon">
        <svg
          width="17"
          height="23"
          viewBox="0 0 17 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.50016 0.302246C6.3428 0.302246 4.59391 2.05113 4.59391 4.2085V10.4585C4.59391 12.6159 6.3428 14.3647 8.50016 14.3647C10.6575 14.3647 12.4064 12.6159 12.4064 10.4585V4.2085C12.4064 2.05113 10.6575 0.302246 8.50016 0.302246ZM6.15641 4.2085C6.15641 2.91408 7.20575 1.86475 8.50016 1.86475C9.79458 1.86475 10.8439 2.91408 10.8439 4.2085V10.4585C10.8439 11.7529 9.79458 12.8022 8.50016 12.8022C7.20575 12.8022 6.15641 11.7529 6.15641 10.4585V4.2085Z"
            fill="#3F3F3F"
          />
          <path
            d="M16.5731 10.4585C16.5731 10.027 16.2233 9.67725 15.7918 9.67725C15.3604 9.67725 15.0106 10.027 15.0106 10.4585C15.0106 12.1852 14.3247 13.8411 13.1037 15.0621C11.8828 16.283 10.2268 16.9689 8.50016 16.9689C6.77349 16.9689 5.11754 16.283 3.8966 15.0621C2.67566 13.8411 1.98975 12.1852 1.98975 10.4585C1.98975 10.027 1.63997 9.67725 1.2085 9.67725C0.777024 9.67725 0.427246 10.027 0.427246 10.4585C0.427246 12.5996 1.27778 14.6529 2.79175 16.1669C4.12045 17.4956 5.86462 18.3133 7.71891 18.4935V21.1356H6.41683C5.98536 21.1356 5.63558 21.4854 5.63558 21.9168C5.63558 22.3483 5.98536 22.6981 6.41683 22.6981H10.5835C11.015 22.6981 11.3647 22.3483 11.3647 21.9168C11.3647 21.4854 11.015 21.1356 10.5835 21.1356H9.28141V18.4935C11.1357 18.3133 12.8799 17.4956 14.2086 16.1669C15.7225 14.6529 16.5731 12.5996 16.5731 10.4585Z"
            fill="#3F3F3F"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.50016 0.302246C6.3428 0.302246 4.59391 2.05113 4.59391 4.2085V10.4585C4.59391 12.6159 6.3428 14.3647 8.50016 14.3647C10.6575 14.3647 12.4064 12.6159 12.4064 10.4585V4.2085C12.4064 2.05113 10.6575 0.302246 8.50016 0.302246ZM6.15641 4.2085C6.15641 2.91408 7.20575 1.86475 8.50016 1.86475C9.79458 1.86475 10.8439 2.91408 10.8439 4.2085V10.4585C10.8439 11.7529 9.79458 12.8022 8.50016 12.8022C7.20575 12.8022 6.15641 11.7529 6.15641 10.4585V4.2085Z"
            stroke="#3F3F3F"
            stroke-width="0.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.5731 10.4585C16.5731 10.027 16.2233 9.67725 15.7918 9.67725C15.3604 9.67725 15.0106 10.027 15.0106 10.4585C15.0106 12.1852 14.3247 13.8411 13.1037 15.0621C11.8828 16.283 10.2268 16.9689 8.50016 16.9689C6.77349 16.9689 5.11754 16.283 3.8966 15.0621C2.67566 13.8411 1.98975 12.1852 1.98975 10.4585C1.98975 10.027 1.63997 9.67725 1.2085 9.67725C0.777024 9.67725 0.427246 10.027 0.427246 10.4585C0.427246 12.5996 1.27778 14.6529 2.79175 16.1669C4.12045 17.4956 5.86462 18.3133 7.71891 18.4935V21.1356H6.41683C5.98536 21.1356 5.63558 21.4854 5.63558 21.9168C5.63558 22.3483 5.98536 22.6981 6.41683 22.6981H10.5835C11.015 22.6981 11.3647 22.3483 11.3647 21.9168C11.3647 21.4854 11.015 21.1356 10.5835 21.1356H9.28141V18.4935C11.1357 18.3133 12.8799 17.4956 14.2086 16.1669C15.7225 14.6529 16.5731 12.5996 16.5731 10.4585Z"
            stroke="#3F3F3F"
            stroke-width="0.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div> -->
    </div>

    <div class="healthPackage">
      <div style="font-size: 1.6rem; margin-top: 1rem" class="left">
        {{ $t("choosehospital") }}
      </div>

      <!-- <div class="hospital-input"> -->
      <el-select
        class="mt-10 white-helthpack"
        id="selectHospital"
        v-model="selectHospital"
        :placeholder="$t('choosehospital')"
        @change="getPackage()"
      >
        <el-option :label="$t('sukhumvit')" value="1"> </el-option>
        <el-option :label="$t('srinakarin')" value="2"> </el-option>
        <el-option :label="$t('thonburi')" value="4"> </el-option>
        <!-- <el-option :label="$t('sriracha')" value="3"> </el-option>
        <el-option :label="$t('chonburi')" value="5"> </el-option>
        <el-option :label="$t('chinatown')" value="6"> </el-option> -->
      </el-select>
    </div>

    <div
      v-if="packageList.length == 0"
      style="text-align: center; font-size: 2rem; padding-top: 10rem"
    >
      {{ $t("notFound") }}
    </div>
    <div class="package-card-container mt-20">
      <div
        v-for="value in packageList"
        :key="value.id"
        class="package-card-old"
        id="packageCard"
      >
        <router-link
          :to="{
            path: '/package-select',
            query: { packageId: value.packageId, hospitalId: value.hospitalId },
          }"
        >
          <div class="content">
            <img class="image" :src="value.imageUrl" :alt="value.packageId" />
            <div class="text">
              <div class="package-name" style="text-overflow: ellipsis">
                {{ value.packageName }}
              </div>
              <!-- <div class="mt-1 fs-9">{{ value.packageDescription }}</div> -->
              <!-- <div class="mt-1 fs-9 uppercase"> -->
              <!-- <div>✚ {{ value.hospitalName }}</div> -->
              <!-- <div v-for="val in value.hopitalAvalible" :key="val.id">
                ✚ {{ val.name }}
              </div> -->
              <!-- </div> -->
              <div class="price">
                <div v-if="value.netPrice == value.listPrice">
                  <div class="price-net-2">
                    {{ numberWithCommasLine(value.netPrice) }}
                  </div>
                </div>
                <div v-else>
                  <div class="price-net">
                    {{ numberWithCommasLine(value.netPrice) }}
                  </div>
                  <div class="price-list">
                    {{ numberWithCommasLine(value.listPrice) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";
import axios from "axios";
import * as config from "@/assets/js/config.js";
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");

export default defineComponent({
  name: "HealthPackage",
  components: {
    Header,
  },
  data() {
    return {
      searchPagkage: "",
      accessToken: null,
      error: null,
      lang: "th",
      allPackageList: [],
      packageList: [],
      selectHospital: "1",
    };
  },
  watch: {
    searchPagkage() {
      this.filterPackage();
    },
  },
  mounted() {
    this.accessToken = this.$cookies.get("access_token");
    this.lang = this.$cookies.get("lang");
    this.getPackage();
  },
  methods: {
    numberWithCommasLine(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ".-";
    },
    filterPackage() {
      let filterPackage = this.allPackageList.filter(
        (apackage) =>
          (
            apackage.packageName +
            " " +
            apackage.categoryName +
            " " +
            apackage.hospitalName +
            " " +
            apackage.packageDescription
          )
            .toLowerCase()
            .indexOf(this.searchPagkage.toLowerCase()) >= 0
      );
      this.packageList = filterPackage;
    },
    getPackage() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/checkup-package/get",
          {
            getCheckupPackageReqBean: {
              hospitalId: this.selectHospital,
              categoryId: null,
              keywords: null,
            },
          },
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((response) => {
          this.allPackageList = response.data;
          this.packageList = response.data;
        })
        .catch((error) => {
          if (error.response.status == 403) {
            this.getNewToken();
          } else {
            this.error = error;
          }
        });
    },
    getNewToken() {
      var refreshToken = this.$cookies.get("refresh_token");
      var token = new AmazonCognitoIdentity.CognitoRefreshToken({
        RefreshToken: refreshToken,
      });

      this.$store.state.userPool = new AmazonCognitoIdentity.CognitoUserPool(
        config.poolData
      );
      const cognitoUser = this.$store.state.userPool.getCurrentUser();
      cognitoUser.refreshSession(token, (err, session) => {
        this.accessToken = session.getIdToken().getJwtToken();
        this.$cookies.set("access_token", this.accessToken);
        this.$cookies.set(
          "refresh_token",
          session.getRefreshToken().getToken()
        );
        window.location.reload();
      });
    },
  },
});
</script>
